<!-- IF checkbox is required -->
<div class="check-box">
    <mat-checkbox *ngIf="formInfos.required" [ngClass]="(positionField === field && onBuilder) ? 'active-control' : ''"
        [(ngModel)]="value" (change)="checkboxValidator($event)">
        {{formInfos.name}}
    </mat-checkbox>
    <mat-error *ngIf="messageError !== 'checked'">
        {{formInfos.requiredAlertMessage ? formInfos.requiredAlertMessage : formInfos.name + ' is required'}}.
    </mat-error>
</div>

<!-- IF checkbox is not required -->
<div>
    <mat-checkbox *ngIf="!formInfos.required" [ngClass]="(positionField === field && onBuilder) ? 'active-control' : ''"
        [(ngModel)]="value" (change)="checkboxValidator($event)">
        {{formInfos.name}}
    </mat-checkbox>
</div>